import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { SkeletonType } from '../../../shared/types/layoutTypes';
import styles from './Loading.module.scss';

export const ServiceSkeleton = (props: SkeletonType) => {
    const { items } = props;
    return (
        <div className={styles.root}>
            {Array.from({ length: items }, (_, index) => (
                <div key={index} className={styles.card}>
                    <Skeleton className={styles.skeleton} height={520} width={392} />
                </div>
            ))}
        </div>
    );
};
